import React, { useState } from 'react'
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import MobileStepper from '@material-ui/core/MobileStepper';
import useStyles from "./Styles.js";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Slider = (props) => {
    const classes = useStyles()
    const [activeStep, setActiveStep] = useState(0);

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    return (
        <div className={classes.sliderContainer}>
            <AutoPlaySwipeableViews index={activeStep} onChangeIndex={handleStepChange} enableMouseEvents className={classes.swiper}>
                {props.render.map(photo => (
                    <div className={classes.slide}>{photo()}</div>
                ))}
            </AutoPlaySwipeableViews>
            <MobileStepper
                variant="dots"
                steps={props.render.length}
                position="static"
                activeStep={activeStep}
                className={classes.progress}
            />
        </div>
    )
}

export default Slider
